import { QueryFunctionContext } from '@tanstack/react-query';

import { SetsConfigService, DEFAULT_SETS_CONFIG_LIMIT } from 'src/services/SetsConfigService';

export const QUERY_KEY = 'sets_configs';

export const querySetsConfigs = (
    context: QueryFunctionContext<App.SetsConfigs.QueryKey, number>,
): Promise<Models.PageResult<Models.IngestConfigApi.SetsConfigs.SetsConfigSummary>> => {
    const { queryKey, pageParam = 0 } = context;
    const [, accessToken, search] = queryKey;
    const limit = search.limit ?? DEFAULT_SETS_CONFIG_LIMIT;

    return SetsConfigService.getSetsConfigs(accessToken, search, pageParam, limit);
};
